/**
 * demo.ts - Demo tournament creation functionality
 */

import { API_URL } from '../utils/constants';

/**
 * Create a demo tournament and navigate to it
 */
export async function createDemoTournament(): Promise<void> {
  const button = document.querySelector('.demo-button') as HTMLButtonElement;
  const i18n = (window as any).i18n;

  if (button) {
    button.disabled = true;
    button.textContent = i18n ? i18n.t('landing.demo.creating') : 'Creating demo tournament...';
  }

  try {
    const response = await fetch(`${API_URL}/tournaments/demo`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include'
    });

    if (!response.ok) {
      throw new Error('Failed to create demo tournament');
    }

    const data = await response.json();
    const tournamentId = data.tournament.id;

    // Redirect to single tournament view
    window.location.href = `/tournament.html?id=${tournamentId}`;

  } catch (error) {
    console.error('Error creating demo tournament:', error);
    const errorMsg = i18n ? i18n.t('landing.demo.error') : 'Failed to create demo tournament. Please try again.';
    alert(errorMsg);
  } finally {
    if (button) {
      button.disabled = false;
      button.textContent = i18n ? i18n.t('landing.demo.button') : 'Launch Demo Tournament';
    }
  }
}

// Make function globally available
(window as any).createDemoTournament = createDemoTournament;
